import blueberryImg from '../../assets/blueberry.jpeg';
import panamablackImg from '../../assets/panamablack.jpeg';
import stoutImg from '../../assets/stout.jpeg';
import strawberryImg from '../../assets/strawberry.jpeg';
import sweetteaImg from '../../assets/sweettea.jpeg';
import vannilaChaiImg from '../../assets/vannilaChai.jpeg';

export const CANS_PER_KEG = 811;

export const FORMAT_DEFINITIONS = {
    cans_rtd: {
        id: 'cans_rtd',
        name: 'Cans (RTD)',
        unit: 'cans',
        container_size_ml: 354.882,
        per_concentrate_keg: 811,
        is_rtd: true,
        pricing: { ws: 3.15, retail: 6.25 }
    },
    keg_5gal_rtd: {
        id: 'keg_5gal_rtd',
        name: '5-Gallon Keg (RTD)',
        unit: 'kegs',
        container_size_ml: 18927,
        // 1 Finished Keg (our base concentrate unit, used undiluted for cans/
        // bottles/gallon concentrate) = 15.5 gal. The 5-Gallon Drinkable Keg is a
        // separate, distinct product: 1 gal concentrate : 4 gal water per keg, so
        // each Drinkable keg only draws 1 gal of concentrate. 15.5 gal / 1 gal
        // per keg = 15.5 Drinkable kegs per Finished Keg.
        per_concentrate_keg: 15.5,
        is_rtd: true,
        pricing: { ws: 135.00, retail: 135.00 }
    },
    bottle_16oz_conc: {
        id: 'bottle_16oz_conc',
        name: '16oz Concentrate',
        unit: 'bottles',
        container_size_ml: 473,
        per_concentrate_keg: 120,
        is_rtd: false,
        pricing: { ws: 18.25, retail: 24.00 }
    },
    bottle_32oz_conc: {
        id: 'bottle_32oz_conc',
        name: '32oz Concentrate',
        unit: 'bottles',
        container_size_ml: 946,
        per_concentrate_keg: 60,
        is_rtd: false,
        pricing: { ws: 33.46, retail: 38.95 }
    },
    gallon_conc: {
        id: 'gallon_conc',
        name: 'Gallon Concentrate',
        unit: 'gallons',
        container_size_ml: 3785,
        per_concentrate_keg: 15,
        is_rtd: false,
        pricing: { ws: 127.50, retail: 153.65 }
    }
};

// Centralized product image mapping
export const PRODUCT_IMAGES = {
    'blueberry basil': blueberryImg,
    'bluseberry basil': blueberryImg, // Matches typo in database
    'panama black': panamablackImg,
    'stout truffle': stoutImg,
    'strawberry hibiscus': strawberryImg,
    'sweet tea lemonade': sweetteaImg,
    'vanilla chai': vannilaChaiImg,
    'maple vanilla chai': vannilaChaiImg,
};
